// extracted by mini-css-extract-plugin
export default {"description":"DescriptionBox_description__3FlZw","descriptionTitle":"DescriptionBox_descriptionTitle__oG+uA","descriptionText":"DescriptionBox_descriptionText__anmsN"};